.content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8rem;
}

.title {
  display: flex;
  gap: 1.6rem;
  align-items: center;
  margin-bottom: 2.4rem;
}

.bullets {
  margin: 2.4rem 0 2.4rem 0;
}

.bullet {
  display: flex;
  gap: 0.6rem;
}

.bullet + .bullet {
  margin-top: 1.2rem;
}

.point {
  flex-shrink: 0;
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.4rem;
  color: var(--color-semantic-text-neutral20);
}

.containerCard {
  display: flex;
  gap: 1.9rem;
  align-items: center;
  margin-bottom: 2.4rem;
}

.icon {
  color: var(--color-semantic-text-neutral20);
}

.link {
  margin-top: 2rem;
}
